__turbopack_context__.v({
  "body": "ItineraryCardBody-module__G1K8eW__body",
  "text": "ItineraryCardBody-module__G1K8eW__text",
  "toggle": "ItineraryCardBody-module__G1K8eW__toggle",
  "toggleIcon": "ItineraryCardBody-module__G1K8eW__toggleIcon",
  "toggleIconExpanded": "ItineraryCardBody-module__G1K8eW__toggleIconExpanded",
  "toggleLabel": "ItineraryCardBody-module__G1K8eW__toggleLabel",
});
